/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Stat_Brokers_Will_CreateInputs */

const cs_import_stat_brokers_will_create = /** @type {(inputs: Import_Stat_Brokers_Will_CreateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Makléři vytvořit: ${i?.count}`)
};

const en_import_stat_brokers_will_create = /** @type {(inputs: Import_Stat_Brokers_Will_CreateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Brokers create: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Brokers create: {count}" |
*
* @param {Import_Stat_Brokers_Will_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_stat_brokers_will_create = /** @type {((inputs: Import_Stat_Brokers_Will_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Stat_Brokers_Will_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_stat_brokers_will_create(inputs)
	return cs_import_stat_brokers_will_create(inputs)
});